import OneOfBulkLeaveWasImportedEvent from '@/components/requests/leave/events/OneOfBulkLeaveWasImportedEvent'

export default class OneOfImportedLeaveWasApprovedEvent extends OneOfBulkLeaveWasImportedEvent {
  asText() {
    return `**Leave Dates** automatically approved the request because it was imported`
  }
}
